import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Pagination from 'rc-pagination';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import messages from '../../locale/messages';
import s from 'rc-pagination/assets/index.css';
import c from '../../styles/rc-pagination.css';

class CustomPagination extends Component {

    static propTypes = {
        total: PropTypes.number.isRequired,
        defaultCurrent: PropTypes.number.isRequired,
        defaultPageSize: PropTypes.number.isRequired,
        change: PropTypes.any.isRequired,
        currentPage: PropTypes.number.isRequired,
        paginationLabel: PropTypes.string
    };

    static defaultProps = {
        paginationLabel: 'items'
    };

    handleChange = (currentPage, size) => {
        const { change, isScroll } = this.props;
        change(currentPage);
        isScroll && window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

    renderShowTotal = (total, range) => {
        const { paginationLabel } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <div>
                <span>{range[0]}</span>
                <span>&nbsp;–&nbsp;</span>
                <span>{range[1]}</span>
                <span>&nbsp;{formatMessage(messages.ofLabel)}&nbsp;</span>
                <span className='paginationRtl'>{total}</span>
                <span>&nbsp;{paginationLabel}</span>
            </div>
        );
    }

    render() {
        const { total, defaultCurrent, defaultPageSize, currentPage } = this.props;
        const locale = { prev_page: 'Previous', next_page: 'Next' };

        return (
            <div className={cx('spaceTop4', 'positionRelative')}>
                <Pagination
                    defaultCurrent={defaultCurrent}
                    current={currentPage}
                    total={total}
                    defaultPageSize={defaultPageSize}
                    onChange={this.handleChange}
                    showTotal={(total, range) => this.renderShowTotal(total, range)}
                    locale={locale}
                    showLessItems
                    prevIcon={<span>&#8249;</span>}
                    nextIcon={<span>&#8250;</span>}
                    jumpPrevIcon={
                        <span className='rc-pagination-jump-custom-icon'>
                            <span className='rc-pagination-jump-beforeHover-icon'>&#8226;&#8226;&#8226;</span>
                            <span className='rc-pagination-jump-afterHover-icon'>&#8249;&#8249;</span>
                        </span>
                    }
                    jumpNextIcon={
                        <span className='rc-pagination-jump-custom-icon'>
                            <span className='rc-pagination-jump-beforeHover-icon'>&#8226;&#8226;&#8226;</span>
                            <span className='rc-pagination-jump-afterHover-icon'>&#8250;&#8250;</span>
                        </span>
                    }
                    align={"center"}
                />
            </div>
        );
    }
}

export default injectIntl(withStyles(s, c)(CustomPagination));